import { AllSubdomain } from "./common";
export const EnvironmentInUse = ["development", "staging", "production"];
export const ReleaseNotes = [
    {
        appName: AllSubdomain.tenantUser.name,
        appVersion: "2.0.1",
        updatedAt: "13122k23",
        environment: EnvironmentInUse,
        // if clearCache true then after first deployment
        // It will remove localStorage and cookies from browser
        // Don't forget to remove
        clearCache: true
    },
    {
        appName: AllSubdomain.tenantAdmin.name,
        appVersion: "2.0.1",
        updatedAt: "Tue Oct 04 2023 14:03:48 GMT+0530",
        environment: EnvironmentInUse,
        // if clearCache true then after first deployment
        // It will remove localStorage and cookies from browser
        // Don't forget to remove
        clearCache: true
    },
    {
        appName: AllSubdomain.tenantCoderprep.name,
        appVersion: "2.0.1",
        updatedAt: "Tue Oct 04 2023 14:03:48 GMT+0530",
        environment: EnvironmentInUse,
        // if clearCache true then after first deployment
        // It will remove localStorage and cookies from browser
        // Don't forget to remove
        clearCache: true
    },
    {
        appName: AllSubdomain.tenantInterviewprep.name,
        appVersion: "2.0.1",
        updatedAt: "Tue Oct 04 2023 14:03:48 GMT+0530",
        environment: EnvironmentInUse,
        // if clearCache true then after first deployment
        // It will remove localStorage and cookies from browser
        // Don't forget to remove
        clearCache: true
    }
];
